import React from 'react';
import { useHistory, useLocation } from 'react-router-dom'
import { useDessinList } from 'redux/hooks';

import {
    Button,
    Divider
} from '@material-ui/core'

import { FlexRowSpaceBetween } from 'layouts/Helpers/flexbox';


export default ({
   // search_type = 'dessin',
    constructPath = artwork => ("/artwork/" + artwork.objectid),
    listPath = '/dessin'
}) => {

    const [ listObject ] = useDessinList("dessin");
    const history = useHistory();
    const location = useLocation();
    const search_context = (location.state && location.state.list) || null;

 //   console.log("ListNav location.state", location.state)
 //   console.log("ListNav listObject", listObject)
 //   console.log("ListNav search_context", search_context)

    if (!listObject.results) {
        return null;
    }

    const goToIndex = index => {
        if (!listObject.results[index]) {
            return;
        }
        history.push(constructPath(listObject.results[index]), {
            context: "global_list",
            list: {
                index
            }
        });
    }


    return (
        <>
            <FlexRowSpaceBetween style={{marginBottom: '10px'}}>
                <Button
                    color="primary" variant="contained"
                    onClick={() => history.push(listPath)}
                >Retour à la liste</Button>
                <div>
                    <Button
                        color="primary" variant="contained" style={{marginRight:'20px'}}
                        onClick={() => goToIndex(search_context.index - 1)}
                    >{"< "}Previous</Button>
                    <Button
                        color="primary" variant="contained"
                        onClick={() => goToIndex(search_context.index + 1)}
                    >Next{" >"}</Button>
                </div>
            </FlexRowSpaceBetween>

            <Divider style={{marginBottom: '10px', marginTop: '10px'}}/>
        </>
    )
}